<template>
    <div class="pop" v-show="show" @click.stop='_=>{}'>
        <div class="box" ref="box">
            <div id="close" class="close_btn" v-if='closeBtn' @click="close();closeCall()"></div>
            <div class="title">{{title}}</div>
            <div class="wrap">
                <div v-html='content'></div>
                <button v-if="hasBtn" class="roger" @click="confirm">{{btnTxt}}</button>
            </div>

        </div>
    </div>
</template>

<script>
    // @ is an alias to /src

    export default {
        name: 'alert',
        data: () => ({
            show: true
        }),
        props: {
            title: {
                default: '提示',
                type: String
            },
            content: {
                default: '',
                type: String
            },
            btnTxt: {
                default: '知道了',
                type: String
            },
            confirmCall: {
                default: () => {},
                type: Function
            },
            hasBtn: {
                type: Boolean,
                default: true
            },
            mountHandle: {
                default: () => {},
                type: Function
            },
            closeBtn: {
                type: Boolean,
                default: false
            },
            closeCall: {
                default: () => {},
                type: Function
            },
        },
        methods: {
            confirm() {
                this.confirmCall()
                this.close()
            },
            close() {
                this.show = false
            }
        },
        watch: {
            mountHandle() {
                this.$nextTick(() => {
                    this.mountHandle(this.close)
                })
            }
        },
        components: {

        },
        mounted() {
            if (window.orderScale) {
                this.$refs.box.style.transform = `translate(0, -50%) scale(${window.orderScale})`
                this.$refs.box.style.right = 153*window.orderScale + 'px'
            }
        }
    }
</script>

<style scoped>
    .pop {
        position: fixed;
        z-index: 2000;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, .2);
    }

    .box {
        width: 494px;
        position: absolute;
        right: 153px;
        top: 50%;
        transform: translate(0, -50%);
        transform-origin: right top;
    }

    .close_btn {
        width: 35px;
        height: 35px;
        position: absolute;
        right: 0;
        top: 0;
        background: url(../assets/image/close.png) no-repeat center;
        background-size: 12px;
        cursor: pointer;
    }

    .title {
        height: 34px;
        background: url(../assets/image/confirm_title_bg.jpg) no-repeat;
        color: #fafafa;
        font-size: 15px;
        line-height: 34px;
        padding-left: 11px;
    }

    .wrap {
        background: #fff;
        border: 1px solid #8b8b8b;
        border-top: 0;
        padding: 30px 60px;
        color: #7c7c7c;
        font-weight: bolder;
        font-size: 14px;
    }

    .roger {
        color: #fff;
        font-weight: bolder;
        background: rgb(73, 132, 212);
        padding: 5px 28px;
        cursor: pointer;
        display: block;
        min-width: 98px;
        zoom: 1;
        margin: 0 auto;
        border: 0;
        margin-top: 25px;
        outline: 0;
    }

    /* @media screen and (max-width: 494px) {
        .box {
            right: 50%;
            transform: translate(50%,-50%);
            width: 95%;
        }
    } */
</style>